import React from 'react'

class FeedbackSection extends React.Component {
  state = {}

  componentDidMount () {}

  render () {
    var content = <div>feedback section</div>

    return content
  }
}

module.exports = FeedbackSection
